import dayjs from "dayjs";
import { Toggle } from "./Toggle";
import { TimePagination } from "./TimePagination";
import { useDateRange } from "../hooks";

export default function CompareToggle({
  compareWithPrevios,
  setCompareWithPrevious,
  visibleRange,
  currentStyle = "bg-primary-400",
  compareStyle = "border-dashed border-2 border-primary-400",
}) {
  const { interval } = useDateRange();

  return (
    <div className="flex justify-between print:hidden mb-6">
      <div className="flex flex-col gap-2 text-gray-700 text-sm">
        <div className="flex items-center gap-1">
          {/*Balken*/}
          <div className="flex flex-col gap-4">
            <div className={"h-1  w-6 " + currentStyle}></div>
            {compareWithPrevios && (
              <div className={"h-1 w-6 " + compareStyle}></div>
            )}
          </div>
          <div className="flex flex-col">
            <strong className="text-[10px] text-gray-500">
              <TimePagination visibleRange={visibleRange.current}>
                {compareWithPrevios && (
                  <span className="text-[10px] text-gray-400">
                    {visibleRange.compare[0] &&
                      dayjs(visibleRange.compare[0] || null).format(
                        "DD.MM.YY"
                      )}{" "}
                    -{" "}
                    {visibleRange.compare[1] &&
                      dayjs(visibleRange.compare[1] || null).format("DD.MM.YY")}
                  </span>
                )}
              </TimePagination>
            </strong>
          </div>
        </div>
      </div>

      <div className="ml-auto flex flex-col gap-3">
        {interval && (
          <Toggle
            checked={compareWithPrevios}
            onToggle={setCompareWithPrevious}
          >
            Vergleichen
          </Toggle>
        )}
      </div>
    </div>
  );
}
